import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import TokenHandler from "src/auth/TokenHandler";
import moment from "moment-timezone";
// Add this to ensure responsiveness
const metaViewport = document.createElement("meta");
metaViewport.name = "viewport";
metaViewport.content =
  "width=device-width, initial-scale=1.0, user-scalable=yes";
document.head.appendChild(metaViewport);

// Set the default timezone to UTC
moment.tz.setDefault("UTC");

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container); // createRoot(container!) if you use TypeScript
  root.render(
    <HelmetProvider>
      <BrowserRouter>
        <TokenHandler>
          <App />
        </TokenHandler>
      </BrowserRouter>
    </HelmetProvider>
  );
}
